import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import Spinner from '../../../../components/spinner/spinner';
import Swal from 'sweetalert2';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import ReportItem from '../../../../components/reportitem/reportitem.component';

const AppointmentReportsList = ({isReport = true}) => {
    const { appointmentDetails } = useAppointmentDetailsContext();
    const [fetching, setFetching] = useState(false);
    const [reports, setReports] = useState([]);

    const apptId = appointmentDetails && appointmentDetails.id;
    useEffect(() => {
        const fetchReports = async () => {
            if (!apptId) return;
            const endpoint = isReport ? 'myappointment-reports' : 'myappointment-prescriptions';
            const url = APIUtils.getAPIEndpoint(endpoint);
            setFetching(true);
            const res = await httpClient.get(`${url}/${apptId}`).then(res => res.data);
            if (res.status === 'success') {
                setReports(res.data);
            } else {
                Swal.fire('Something Went Wrong!', '', 'error');
            }
            setFetching(false);
        };

        document.addEventListener(CUSTOM_EVENTS.REFECTH_REPORTS, fetchReports);
        if (apptId) {
            fetchReports();
        }

        return () => {
            document.removeEventListener(CUSTOM_EVENTS.REFECTH_REPORTS, fetchReports);
        };
    }, [apptId, isReport]);

    const reportsList = reports.map(report => {
        const reportData = !isReport ? {...report, report: report.prescription, isReport} : report;
        return <ReportItem key={report.id} reportData={reportData} />;
    });

    const emptyConversationsUI = () => {
        const reportType = isReport ? 'Reports' : 'Prescriptions';
        return (
            <div className='empty-conversation-container'>
                <Box>
                    <Typography variant="h6" gutterBottom>
                        No {reportType}
                    </Typography>
                    <Typography variant="caption" display="block" gutterBottom>
                        Uploaded {reportType} can be viewed here.
                    </Typography>
                </Box>
            </div>
        );
    };

    if (fetching) {
        return <Spinner inline={false} />;
    }

    if (reports.length < 1) {
        return emptyConversationsUI();
    }

    return reportsList;
};

export default AppointmentReportsList;

AppointmentReportsList.propTypes = {
    isReport: PropTypes.bool,
};